import datetime from 'node-datetime'

export class DateTools {
  constructor (date) {
    this.date = new Date(date)
    this.backup = new Date(date)
    this.monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ]
    this.json = {
      ...this.toJSON()
    }
  }

  toJSON () {
    return {
      fullYear: this.date.getFullYear(),
      UTCFullYear: this.date.getUTCFullYear(),
      month: this.date.getMonth(),
      monthName: this.getMonthName(),
      UTCMonth: this.date.getUTCMonth(),
      date: this.date.getDate(),
      UTCDate: this.date.getUTCDate(),
      day: this.date.getDay(),
      UTCDay: this.date.getUTCDay(),
      hour: this.date.getHours(),
      UTCHour: this.date.getUTCHours(),
      minutes: this.date.getMinutes(),
      UTCMinutes: this.date.getUTCMinutes(),
      seconds: this.date.getSeconds(),
      UTCSeconds: this.date.getUTCSeconds()
    }
  }

  getMonthName () {
    return this.monthNames[this.date.getMonth()]
  }

  getMonth () {
    return this.date.getMonth()
  }

  getDate () {
    return this.date
  }

  restore () {
    this.date = new Date(this.backup)
    return this
  }

  alterYear (number) {
    this.date.setFullYear(this.date.getFullYear() + number)
    return this
  }

  alterMonth (number) {
    this.date.setMonth(this.date.getMonth() + number)
    return this
  }

  alterDate (number) {
    this.date.setDate(this.date.getDate() + number)
    return this
  }

  alterHour (number) {
    this.date.setHours(this.date.getHours() + number)
    return this
  }

  alterMinute (number) {
    this.date.setMinutes(this.date.getMinutes() + number)
    return this
  }

  alterSeconds (number) {
    this.date.setSeconds(this.date.getSeconds() + number)
    return this
  }

  formatDate (format) {
    var date = datetime.create(this.date)
    var formattedDate = date.format(format)

    return formattedDate
  }
}
